import { ShieldCheck } from "lucide-react";

const CARDS = ["Visa", "Mastercard", "Maestro", "American Express", "PayPal"];

export default function TrustBadges({ variant = "light", className = "" }) {
  const isDark = variant === "dark";
  return (
    <div className={`flex flex-col items-center gap-3 ${className}`} data-testid="trust-badges">
      <div className={`flex items-center gap-2 text-xs uppercase tracking-[0.15em] ${isDark ? "text-bone/70" : "text-ink-soft"}`}>
        <ShieldCheck size={16} strokeWidth={1.6} className="text-claret" />
        Pagamenti sicuri e crittografati
      </div>
      <div className="flex flex-wrap items-center justify-center gap-2">
        {CARDS.map((c) => (
          <span
            key={c}
            className={`text-[11px] px-2.5 py-1 border ${isDark ? "border-bone/20 text-bone/75" : "border-ink/15 text-ink/70 bg-white"}`}
          >
            {c}
          </span>
        ))}
      </div>
    </div>
  );
}
